var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"img-lazyload",style:(_vm.style),attrs:{"src":_vm.imageSource,"srcset":_vm.imageSourceSet,"data-src":_vm.lazySrc,"data-srcset":_vm.lazySrcset,"loading":_vm.loading},on:{"error":_vm.errorImg,"load":_vm.onLoad}})}
var staticRenderFns = []

export { render, staticRenderFns }